interface Props {
  title: string;
  value: number;
}

const StatCard: React.FC<Props> = ({ title, value }) => {
  return (
    <div style={{
      border: "1px solid #ddd",
      padding: "16px",
      borderRadius: "8px",
      width: "200px"
    }}>
      <h4>{title}</h4>
      <h2>{value}</h2>
    </div>
  );
};

export default StatCard;
